import Layout from "components/structure/Layout";
import React, { useContext, useEffect, useState } from "react";
import { Button, CircularProgress, FormControl, Grid, MenuItem, TextField, Typography } from "@mui/material";
import plusIcon from "../../../../src/assets/plusIcon.svg"
import { Box } from "@mui/system";
import HierarchyModal from "./HierrachyModal";
import CopyHierarchyModal from "./CopyHierarchyModal";
import HierarchyTable from "./HierarchyTable";
import HierarchyService from "services/HierarchyService";
import SeasonRegistrationService from "services/SeasonRegistrationService";
import { SnackbarContext } from "context/snackBarContext";
import Pagination from "./Paginationcc";
import { AuthData } from "auth/AuthWarpper";

const HierarchyContainer = () => {
    const { user } = AuthData();
    const [modalOpen, setModalOpen] = useState(false);
    const [copyModalOpen, setCopyModalOpen] = useState(false);
    const [copyLoading, setCopyLoading] = useState(false);
    const [previousYearHasData, setPreviousYearHasData] = useState(false);
    const [checkingPreviousYear, setCheckingPreviousYear] = useState(false);
    const [hierarchyData, sethierarchyData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { setOpenAlert, setSeverity, setMessage, handleClose } =
        useContext(SnackbarContext);
    const [string, setString] = React.useState("");

    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5); // Number of items per page
    const [totalItems, setTotalItems] = useState(5); // Number of items per page

    const [cropYears, setCropYears] = useState([]);
    const [selectedCropYear, setSelectedCropYear] = useState("");
    const [fetchedForYear, setFetchedForYear] = useState(null);

const moduleName = "Manage Operations";
const functionalityName = "Hierarchy Configuration";

  const read_only_user = user?.accessibleModules
    ?.find(module => module.module_name === moduleName)
    ?.accessible_functionalities
    ?.find(func => func.functionality_name === functionalityName)
    ?.read_only;

    useEffect(() => {
        SeasonRegistrationService.getCropYears()
            .then((response) => {
                const cropYearsFromApi = (response?.data?.response || []).map((item) => item.cropYear);
                setCropYears(cropYearsFromApi);
                if (cropYearsFromApi.length > 0) {
                    const defaultYear = Math.max(...cropYearsFromApi);
                    setSelectedCropYear(defaultYear);
                    callHierarchyAPI(0, itemsPerPage, defaultYear);
                }
            })
            .catch((error) => {
                setMessage(error?.response?.data?.message || error?.message)
                setOpenAlert(true)
                setSeverity("error")
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const callHierarchyAPI = (pNumber, size, cropYear = selectedCropYear) => {
        setLoading(true)
        HierarchyService.FetchAllHierarchy({ pageNumber: pNumber, size: size, cropYear: cropYear })
            .then((res) => {
                setCurrentPage(pNumber)
                setItemsPerPage(size)
                setLoading(false)
                sethierarchyData(res?.data?.response);
                setTotalItems(res?.data?.response?.totalItems)
                setFetchedForYear(cropYear)
            }).catch((error) => {
                setLoading(false)
                sethierarchyData(null)
                setTotalItems(0)
                setCurrentPage(pNumber)
                setItemsPerPage(size)
                setFetchedForYear(cropYear)
                setMessage(error?.response?.data?.message || error?.message)
                setOpenAlert(true)
                setSeverity("error")
            })
    }

    const handleCropYearChange = (e) => {
        const newYear = e.target.value;
        setSelectedCropYear(newYear);
    }

    const handleGetClick = () => {
        callHierarchyAPI(0, itemsPerPage, selectedCropYear);
    }

    const handleAddNewLevelClick = () => {
        const isEmptyForYear = !hierarchyData || !hierarchyData.hierarchyLevelConfig || hierarchyData.hierarchyLevelConfig.length === 0;
        if (!isEmptyForYear) {
            setModalOpen(true);
            return;
        }
        setCheckingPreviousYear(true)
        HierarchyService.FetchAllHierarchy({ pageNumber: 0, size: 1, cropYear: selectedCropYear - 1 })
            .then((res) => {
                setCheckingPreviousYear(false)
                const hasData = (res?.data?.response?.hierarchyLevelConfig?.length || 0) > 0;
                setPreviousYearHasData(hasData)
                setCopyModalOpen(true)
            }).catch(() => {
                setCheckingPreviousYear(false)
                setPreviousYearHasData(false)
                setCopyModalOpen(true)
            })
    }

    const handleCopyYes = () => {
        setCopyLoading(true)
        HierarchyService.copyHierarchyLevel(selectedCropYear).then((res) => {
            setCopyLoading(false)
            setCopyModalOpen(false)
            setMessage(res?.data?.message || "Copied successfully")
            setOpenAlert(true)
            setSeverity(res?.data?.statusCode === 200 ? "success" : "error")
            callHierarchyAPI(0, itemsPerPage, selectedCropYear)
        }).catch((error) => {
            setCopyLoading(false)
            setCopyModalOpen(false)
            setMessage(error?.response?.data?.message || error?.message)
            setOpenAlert(true)
            setSeverity("error")
        })
    }

    const handleCopyNo = () => {
        setCopyModalOpen(false)
        setModalOpen(true)
    }


    const onSubmitLevel = () => {
        let level = {
            hlcLevelName: string,
            createdByUser: user ? user.userName : "",
            modifiedByUser: user ? user.userName : "",
            country: user ? user.countryCode : "",
            cropYear: selectedCropYear,
            isActive: true,
        }
        setLoading(true)
        HierarchyService.addLevel(level).then((res) => {
            setLoading(false)
            setMessage("Added successfully")
            setOpenAlert(true)
            setSeverity("success")
            callHierarchyAPI(currentPage, itemsPerPage)
            setModalOpen(false);
            setString("")


        }).catch((error) => {
            setLoading(false)
            setMessage(error?.response?.data?.message || error?.message)
            setOpenAlert(true)
            setSeverity("error")
        })

    }


    const paginate = (pageNumber, itemsPerPage) => {
        callHierarchyAPI(pageNumber - 1, itemsPerPage)
    }

    const handleInputChange = (str) => {
        const sanitized = str.replace(/^\s+/, '').replace(/\s{2,}/g, ' ');
        setString(sanitized);
    };
    return (
            <Layout title={"Hierarchy Level Configuration"}>
            <div className="hierarchyConatiner">
                <Grid item xs={13} md={12} display={"flex"} sx={{flexDirection:{xs:"column" ,md:"row"}}} justifyContent={"space-between"} alignItems={"center"}>
                    <Box sx={{
                        display:"flex",
                        alignItems:"center",
                        fontWeight: 600,
                        fontSize: "1.25rem",
                        color: "rgba(115, 125, 134, 1)",
                    }}>
                        Hierarchy Configuration List
                    </Box>
                    <Box sx={{ right: '1.6rem', padding: "10px" }}>
                        <Button style={{backgroundColor: (read_only_user || !selectedCropYear || checkingPreviousYear || fetchedForYear !== selectedCropYear) ? "#C0C0C0" : "#004F9F",borderRadius: "30px",color: "#fff", height: "40px" }}
                            variant="contained"
                            startIcon={<img src={plusIcon} />}
                            disabled={read_only_user || !selectedCropYear || checkingPreviousYear || fetchedForYear !== selectedCropYear}
                            onClick={handleAddNewLevelClick}
                        >
                            Add new Level</Button>
                    </Box>
                </Grid>
                <Grid item xs={12} display={"flex"} alignItems={"center"} sx={{ mt: ".1rem", mb: "1rem" }}>
                    <FormControl sx={{ m: 1, minWidth: { xs: 150, md: 300 }, minHeight: 50 }}>
                        <TextField
                            select
                            value={selectedCropYear}
                            onChange={handleCropYearChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Crop Year" }}
                            label={selectedCropYear ? "" : "Crop Year"}
                        >
                            {cropYears.map((cropYear) => (
                                <MenuItem key={cropYear} value={cropYear}>
                                    {cropYear}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormControl>
                    <Button
                        sx={{
                            borderRadius: 10,
                            minWidth: 95,
                            minHeight: 44,
                            background: "#102A62",
                            marginTop: { xs: 1 },
                            marginLeft: { xs: 1 },
                        }}
                        startIcon={loading && <CircularProgress size={20} />}
                        variant="contained"
                        onClick={handleGetClick}
                        disabled={!selectedCropYear || loading}
                    >
                        Get</Button>
                </Grid>
                <HierarchyTable setHierarchynull={() => sethierarchyData([])} callHierarchyAPI={() => callHierarchyAPI(currentPage, itemsPerPage)} hierarchyData={hierarchyData} read_only_user={read_only_user} cropYear={selectedCropYear}></HierarchyTable>
                {!hierarchyData || hierarchyData.length == 0 ?
                    <Typography style={{ textAlign: "center", marginTop: "5%" }}>No Data</Typography>
                    : ""
                }

                <HierarchyModal loading={loading} string={string} onLevelNameInput={(str) => { handleInputChange(str) }} onNext={() => { onSubmitLevel() }} open={modalOpen} onClose={() => { setModalOpen(false) }} />
                <CopyHierarchyModal
                    open={copyModalOpen}
                    cropYear={selectedCropYear}
                    loading={copyLoading}
                    hasPreviousYearData={previousYearHasData}
                    onYes={handleCopyYes}
                    onNo={handleCopyNo}
                    onClose={() => setCopyModalOpen(false)}
                />
            </div>
            <div style={{ position: "absolute", width: "96%", bottom: "24px" }}>
                {hierarchyData && hierarchyData?.hierarchyLevelConfig &&
                    <Pagination
                        itemsPerPage={itemsPerPage}
                        totalItems={totalItems}
                        paginate={paginate}
                        currentPage={currentPage}
                    />
                }

            </div>

        </Layout>
    );
};


export default HierarchyContainer;
